export const dialogueSequenceStart = [
  {
    character: "",
    text: "After a fantastic picnic, Carrot and Broccoli return home, chatting about their adventures.",
    imgLinkBroccoli: "",
    imgLinkCarrot: "",
  },
  {
    character: "carrot",
    text: "What a marvelous picnic, Broccoli! And it was healthy too!",
    imgLinkBroccoli: "broccoli3",
    imgLinkCarrot: "carrot2",
  },
  {
    character: "broccoli",
    text: "Totally! Now that we're back home... how about another challenge?",
    imgLinkBroccoli: "broccoli2",
    imgLinkCarrot: "carrot1",
  },
  {
    character: "carrot",
    text: "Ooo, what do you have in mind?",
    imgLinkBroccoli: "broccoli4",
    imgLinkCarrot: "carrot3",
  },
  {
    character: "broccoli",
    text: "Let's build a Healthy Food Tower—five stories tall! And only healthy food is allowed!",
    imgLinkBroccoli: "broccoli2",
    imgLinkCarrot: "carrot1",
  },
  {
    character: "carrot",
    text: "That sounds so fun! Let's see if we can stack all 5 floors without toppling it!",
    imgLinkBroccoli: "broccoli3",
    imgLinkCarrot: "carrot2",
  },
];
